// AUTOGENERATED FILE - DO NOT EDIT

/**
 * All IAM policy actions for AWS IQ Permissions (IQ-PERMISSION)
 *
 * Extracted by `aws-iam-policy` from
 * https://docs.aws.amazon.com/service-authorization/latest/reference/list_awsiqpermissions.html
 *
 * 2025-02-24T21:48:29.109Z
 */
export enum AwsIqPermissionActions {
  /**
   * Grants permission to approve a permission request
   *
   * See https://aws.amazon.com/iq/
   */
  ApproveAccessGrant = 'iq-permission:ApproveAccessGrant',
  /**
   * Grants permission to approve a permission request
   *
   * See https://aws.amazon.com/iq/
   */
  ApprovePermissionRequest = 'iq-permission:ApprovePermissionRequest',
  /**
   * Grants permission to obtain a set of temporary security credentials for experts
   * which they can use to access buyers' AWS resources
   *
   * See https://aws.amazon.com/iq/
   */
  AssumePermissionRole = 'iq-permission:AssumePermissionRole',
  /**
   * Grants permission to create a permission request
   *
   * See https://aws.amazon.com/iq/
   */
  CreatePermissionRequest = 'iq-permission:CreatePermissionRequest',
  /**
   * Grants permission to get a permission request
   *
   * See https://aws.amazon.com/iq/
   */
  GetPermissionRequest = 'iq-permission:GetPermissionRequest',
  /**
   * Grants permission to list permission requests
   *
   * See https://aws.amazon.com/iq/
   */
  ListPermissionRequests = 'iq-permission:ListPermissionRequests',
  /**
   * Grants permission to reject a permission request
   *
   * See https://aws.amazon.com/iq/
   */
  RejectPermissionRequest = 'iq-permission:RejectPermissionRequest',
  /**
   * Grants permission to revoke a permission request which was previously approved
   *
   * See https://aws.amazon.com/iq/
   */
  RevokePermissionRequest = 'iq-permission:RevokePermissionRequest',
  /**
   * Grants permission to withdraw a permission request that has not been approved o
   * r declined
   *
   * See https://aws.amazon.com/iq/
   */
  WithdrawPermissionRequest = 'iq-permission:WithdrawPermissionRequest',
}
